import { ComputedRef, onMounted, onUnmounted, type Ref } from "vue";
import { FOCUSABLE_ELS } from "@/src/design_system/layouts_and_containers/dialog/constants/focusTrap";

type UseFocusTrapOptions = {
  dialogRef: Ref<HTMLElement | null>;
  isModal: ComputedRef<boolean> | Ref<boolean>;
};

export const useFocusTrap = ({ dialogRef, isModal }: UseFocusTrapOptions) => {
  const handleKeydown = (e: KeyboardEvent) => {
    if (e.key !== "Tab" || !dialogRef.value || !isModal.value) return;

    // Native modal containment also traverses the media controls' browser-owned shadow DOM.
    if (dialogRef.value.matches(":modal") && dialogRef.value.querySelector("audio[controls], video[controls]")) {
      return;
    }

    const focusable = dialogRef.value.querySelectorAll<HTMLElement>(FOCUSABLE_ELS);

    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  onMounted(() => dialogRef.value?.addEventListener("keydown", handleKeydown));
  onUnmounted(() => dialogRef.value?.removeEventListener("keydown", handleKeydown));
};
